//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

import { createSelector } from 'reselect';

import { IGallery } from '@apis/galleries/galleriesApiModels';
import GalleryDisplayName from '@galleries/models/GalleryDisplayName';
import { getAllAlphabetizedGalleries } from '@galleries/selectors/getAllAlphabetizedGalleries';
import { getAllInstaShopGalleries } from '@galleries/selectors/getAllInstaShopGalleries';
import { isInstaShopGallery } from '@galleries/utils/isInstaShopGallery';

export const getGalleriesForCheckboxList = createSelector(
  getAllAlphabetizedGalleries,
  getAllInstaShopGalleries,
  (galleries, allInstaShops) => {
    let hasFoundInstaShop = false;
    const galleryList: IGallery[] = [];
    const instaShopDisplayName =
      allInstaShops.length > 1 ? 'InstaShops' : 'InstaShop';

    // We only want to show one InstaShop gallery in our list of checkboxes
    for (const gallery of galleries) {
      const isInstaShop = isInstaShopGallery(gallery);

      if (!isInstaShop) {
        galleryList.push(gallery);
      } else if (isInstaShop && !hasFoundInstaShop) {
        // We don't care what this InstaShop gallery's actual name is
        // we just need a checkbox to represent all InstaShop galleries
        const instaShopGalleryForCheckbox: IGallery = {
          ...gallery,
          displayName: GalleryDisplayName(instaShopDisplayName),
        };
        galleryList.push(instaShopGalleryForCheckbox);
      }

      hasFoundInstaShop = hasFoundInstaShop || isInstaShop;
    }

    return galleryList;
  },
);
